module.exports = __webpack_public_path__ + "static/media/idea.ba9a949d.png";